import React from 'react';
import './AssociationComponent.css';

const AssociationComponent = () => {
  return (
    <div className="association-section">
      <div className="association-container">
        <div className="trusted-by-row">
          <p className="trusted-by-text">Trusted by:</p>
        </div>
        <div className="brands-row">
          <div className="brand-col">
            <div className="brand-logo">
              <svg viewBox="0 0 100 40" className="logo-svg">
                <path d="M20 10L30 20L20 30L10 20Z" fill="#888"/>
              </svg>
            </div>
          </div>
          <div className="brand-col">
            <div className="brand-logo">
              <svg viewBox="0 0 120 40" className="logo-svg">
                <rect x="10" y="15" width="15" height="15" fill="#888"/>
                <text x="30" y="25" fontSize="12" fill="#888">Logoipsum</text>
              </svg>
            </div>
          </div>
          <div className="brand-col">
            <div className="brand-logo">
              <svg viewBox="0 0 100 40" className="logo-svg">
                <circle cx="20" cy="15" r="5" fill="#888"/>
                <circle cx="20" cy="25" r="5" fill="#888"/>
                <circle cx="30" cy="15" r="5" fill="#888"/>
                <circle cx="30" cy="25" r="5" fill="#888"/>
              </svg>
            </div>
          </div>
          <div className="brand-col">
            <div className="brand-logo">
              <svg viewBox="0 0 120 40" className="logo-svg">
                <text x="10" y="25" fontSize="14" fill="#888">Logoipsum</text>
              </svg>
            </div>
          </div>
          <div className="brand-col">
            <div className="brand-logo">
              <svg viewBox="0 0 120 40" className="logo-svg">
                <text x="10" y="25" fontSize="12" fill="#888" fontWeight="bold">LOGOIPSUM</text>
              </svg>
            </div>
          </div>
          <div className="brand-col">
            <div className="brand-logo">
              <svg viewBox="0 0 120 40" className="logo-svg">
                <ellipse cx="60" cy="20" rx="50" ry="12" fill="none" stroke="#888" strokeWidth="2"/>
                <text x="35" y="25" fontSize="10" fill="#888">logoipsum</text>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssociationComponent;
